'use client';

import React from 'react';

import { Box, Button, Divider, HStack, VStack } from '@chakra-ui/react';

import { useAppDispatch, useAppSelector } from '@hooks/store';
import { MAXIMUM_MENTOR_EXPERIENCE } from '@modules/find-mentor/constants';
import { clearFilters } from '@modules/find-mentor/slice';

import AvailabilityFilter from './AvailabilityFilter';
import ExperienceFilter from './ExperienceFilter';

type FilterProps = {
    isMobile?: boolean;
};
const Filters = ({ isMobile = false }: FilterProps) => {
    const {
        expertise,
        totalExperienceMin,
        totalExperienceMax,
        totalRating,
        query,
        orderBy,
        fromDate,
        toDate,
    } = useAppSelector(state => state.reducer.mentorFilters);
    const dispatch = useAppDispatch();
    const isFilterApplied = () => {
        if (
            expertise.length > 0 ||
            totalExperienceMin > 0 ||
            (totalExperienceMax > 0 && totalExperienceMax < MAXIMUM_MENTOR_EXPERIENCE) ||
            totalRating > 0 ||
            query ||
            orderBy ||
            (fromDate && toDate)
        ) {
            return true;
        }
        return false;
    };
    return (
        <Box
            py={{ base: 0, sm: 0, md: 0 }}
            w={isMobile ? '90%' : '100%'}
            maxW={isMobile ? '100%' : '100%'}
        >
            <VStack gap={5} width="100%">
                <HStack justifyContent="space-between" width="100%">
                    {isFilterApplied() ? (
                        <Button
                            type="button"
                            fontWeight={500}
                            variant="ghost"
                            px={0}
                            fontSize="14px"
                            color="primary.light"
                            onClick={() => {
                                dispatch(clearFilters());
                            }}
                        >
                            Clear All Filters
                        </Button>
                    ) : null}
                </HStack>
                <AvailabilityFilter />
                <Divider />
                <ExperienceFilter />
            </VStack>
        </Box>
    );
};

export default Filters;
